module.exports = __webpack_public_path__ + "static/media/icon_preview.f59a3a58.svg";